export default __webpack_public_path__ + "static/media/telefono.e6614253.png";